import wrapperHOC from "@Utils/wrapperHOC";
import loadable from "@loadable/component";
// import MapSectionChinaDesktop from "./MapSectionChinaDesktop";
// import MapSectionChinaMobile from "./MapSectionChinaMobile";

const mapFallback = <section style={{ height: "340px" }} id="map" />;

const MapSectionV3 = loadable(() => import("../MapSectionV3"), {
  fallback: mapFallback,
});
const MapSectionV3Mobile = loadable(() => import("../MapSectionV3/MapSectionV3Mobile"), {
  fallback: mapFallback,
});

const MapLocationChina = ({ isDesktop = false }) =>
  isDesktop ? <MapSectionV3 isDesktop /> : <MapSectionV3Mobile />;
export default wrapperHOC(MapLocationChina, {
  componentName: "MapLocationChina",
  showForChina: true,
});
